// extracted by mini-css-extract-plugin
export default {"screen-wrapper":"PopUp_screen-wrapper__0UK+M","popup-wrapper":"PopUp_popup-wrapper__w8HZD","exit-button":"PopUp_exit-button__AzcA9"};